import React from "react";
import axios from "axios";
import { useCopies } from "../useCopies";
import { getSessionExpiredMsg } from "shared/utils/network";
import { errorToast, isToastActive } from "shared/utils/toastNotification";
import { API_SESSION_EXPIRE_STATUS_CODE, SESSION_EXPIRE_TOAST_ID } from "shared/utils/constants";

/**
 * On session expire, it shows error message and redirects to login screen
 * pass `ignoreLogoutOnAccessDenied = true` , if you want to disable access denied check for any specific api call
 * @param logout
 * @returns
 */
export function useLogoutOnAccessDenied(logout: Function) {
  const [interceptorInitialized, setInterceptorInitialized] = React.useState(false);
  const copies = useCopies();
  React.useEffect(() => {
    setInterceptorInitialized(true);
    const interceptor = axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error?.response?.status === API_SESSION_EXPIRE_STATUS_CODE && !error?.config?.ignoreLogoutOnAccessDenied) {
          if (!isToastActive(SESSION_EXPIRE_TOAST_ID)) {
            errorToast(getSessionExpiredMsg(copies), {
              autoClose: false,
              toastId: SESSION_EXPIRE_TOAST_ID
            });
          }
          logout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [logout, copies]);
  return interceptorInitialized;
}
